



















































import mixins from "vue-typed-mixins"
import DisplayMixin from "../../mixins/Display.vue"
import InputMixin from "../../mixins/Input.vue"
import Eyes from "../../inputs/nihss/Eyes.vue"

export default mixins(DisplayMixin, InputMixin).extend({
    components: {
        Eyes,
    },
    props: {
        stay_id: {
            type: Number,
            required: true
        },
        section: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            gazeEnums: {
                unable: ['UNABLE_TO_LOOK_RIGHT', 'UNABLE_TO_LOOK_LEFT'],
                forced: ['FORCED_DEVIATION_TO_RIGHT', 'FORCED_DEVIATION_TO_LEFT']
            }
        }
    },
    computed: {
        debugMode(): boolean {
            return this.$store.direct.state.user.debug_mode
        },
        gazeDebugText(): string {
            return `gaze: ${this.gazeNormal ? "normal" : this.gaze}`
        },
        gazeNormal: {
            get(): boolean | null | undefined {
                return this.getFieldVal(this.stay_id, `${this.section}.gaze_normal`)
            },
            set(val: boolean | null) {
                this.setFieldVal(this.stay_id, `${this.section}.gaze_normal`, val)                
            }
        },
        gaze: {
            get(): string | null | undefined {
                return this.getFieldVal(this.stay_id, `${this.section}.gaze`)
            },
            set(val: string | null) {
                this.setFieldVal(this.stay_id, `${this.section}.gaze`, val)
            }
        }
    },
    watch: {
        gazeNormal(val) {
            if (val)
                this.gaze = null
        },
        gaze(val) {
            if (val)
                this.gazeNormal = null
        }
    },
})
